export const CustomerTypes = {
  dealer: 'dealer',
  agent: 'agent',
  normal: 'normal',
  pos: 'pos',
};
